import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { NavigationError } from '@angular/router';
import packageJson from '../../../../package.json';

const recoveryStorageKey = 'mt-ascup:chunk-load-recovery';
const recoveryQueryParam = 'appReload';
const importFailurePattern =
  /^(Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk \S+ failed)/i;

@Injectable({ providedIn: 'root' })
export class ChunkLoadRecoveryService {
  private readonly document = inject(DOCUMENT);
  private reloadPending = false;

  recover(event: NavigationError): void {
    const browser = this.document.defaultView;
    const error: unknown = event.error;
    if (
      !browser ||
      !(error instanceof Error) ||
      !importFailurePattern.test(error.message) ||
      !event.url.startsWith('/') ||
      event.url.startsWith('//')
    ) {
      return;
    }

    const current = new URL(browser.location.href);
    const target = new URL(event.url, current.origin);
    if (target.origin !== current.origin || this.reloadPending) return;

    if (browser.navigator.onLine === false) {
      browser.alert(
        'Не удалось открыть раздел. Проверьте соединение с сетью и повторите переход.',
      );
      return;
    }

    let alreadyReloaded =
      current.searchParams.get(recoveryQueryParam) === packageJson.version;
    let storageAvailable = true;
    try {
      alreadyReloaded ||=
        browser.sessionStorage.getItem(recoveryStorageKey) ===
        packageJson.version;
    } catch {
      storageAvailable = false;
    }
    if (alreadyReloaded) {
      browser.alert(
        'Не удалось открыть раздел после обновления приложения. Повторите попытку позже. Если ошибка сохраняется, обратитесь в поддержку.',
      );
      return;
    }

    try {
      browser.sessionStorage.setItem(recoveryStorageKey, packageJson.version);
    } catch {
      storageAvailable = false;
    }
    if (!storageAvailable) {
      target.searchParams.set(recoveryQueryParam, packageJson.version);
    }
    this.reloadPending = true;
    browser.location.replace(target.href);
  }
}
